export const colorCodes = [
    "#FF5733", // Vivid Red
    "#33FF57", // Vivid Green
    "#3357FF", // Vivid Blue
    "#FF33A1", // Vivid Pink
    "#A133FF", // Vivid Purple
    "#33FFF7", // Vivid Cyan
    "#FFB833", // Vivid Orange
    "#A1FF33", // Vivid Lime
    "#FF3333", // Vivid Red (different shade)
    "#333FFF", // Vivid Indigo
    "#FF333F", // Vivid Magenta
    "#33FF33", // Vivid Chartreuse
    "#3377FF", // Vivid Azure
    "#FF3357", // Vivid Rose
    "#FF5733", // Vivid Vermilion
    "#33FF77", // Vivid Spring Bud
    "#33FFA1", // Vivid Turquoise
    "#33FFD5", // Vivid Cyan (different shade)
    "#FF33D5", // Vivid Fuchsia
    "#FF7733", // Vivid Tangelo
    "#FFA133", // Vivid Amber
    "#FFD533", // Vivid Electric Yellow
    "#77FF33", // Vivid Green (different shade)
    "#A133FF", // Vivid Purple (different shade)
    "#D533FF", // Vivid Orchid
    "#FF33D5", // Vivid Heliotrope
    "#FF33A1", // Vivid Cerise
    "#FF5733", // Vivid Red (different shade)
    "#33FF57", // Vivid Green (different shade)
    "#3357FF"  // Vivid Blue (different shade)
  ];